import React, {useCallback} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useCustomerMgr, useNotify} from 'coreHooks';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';

import {IAddToWishlistSuccessMsgProps} from './IAddToWishlistSuccessMsg';
import messages from './messages';

import styles from './AddToWishlistSuccessMsg.module.scss';

const AddToWishlistSuccessMsg = ({classNames, isRemoved, moved = false}: IAddToWishlistSuccessMsgProps) => {
	const {managerRepository} = useGeneralProvider();
	const CustomerMgr = useCustomerMgr();
	const customer = CustomerMgr.getCurrentCustomer();
	const intl = useIntl();
	const notify = useNotify();

	const onViewClick = () => {
		notify.dismiss();
		managerRepository.getFlyoutsMgr().openFlyout('wishlist', true);
	};

	const onLoginClick = useCallback(() => {
		notify.dismiss();
		managerRepository.getFlyoutsMgr().openFlyout('login', true);
	}, [notify]);

	return (
		<div className={cn(classNames, styles['add-to-wishlist-success-msg'], 'add-to-wishlist-success-msg', {'add-to-wishlist-success-removed': isRemoved})}>
			<div className="add-to-wishlist-success-msg__header">
				<span>
					{moved
						? intl.formatMessage(messages.successMovedFromCartMsg)
						: isRemoved
							? intl.formatMessage(messages.successRemovedMsg)
							: intl.formatMessage(messages.successMsg)
					}
				</span>
				<span className="view-all" onClick={onViewClick}>
					{intl.formatMessage(messages.linkLabel)}
				</span>
			</div>
			{customer?.isGuest && (
				<div className="add-to-wishlist-success-msg__bottom">
					<span>{intl.formatMessage(messages.guestMsg)}</span>
					<div className="add-to-wishlist-success-msg__ctas">
						<Button onClick={() => notify.dismiss()}>{intl.formatMessage(messages.dismissLabel)}</Button>
						<Button onClick={onLoginClick}>{intl.formatMessage(messages.loginLabel)}</Button>
					</div>
				</div>
			)}
		</div>
	);
};

export default AddToWishlistSuccessMsg;
